import { render, staticRenderFns } from "./WorkforceReportTable.vue?vue&type=template&id=9e4dcbba&"
import script from "./WorkforceReportTable.vue?vue&type=script&lang=js&"
export * from "./WorkforceReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports